import { api } from "@/service/api";

export default {

    listarSetoresDescricao: async () => {
        return await api.get('setor/listardistinct')
    },
    listarSetores: async () => {
        return await api.get('setor/listar')
    },
    listarPessoas: async () => {
        return await api.get('pessoa')
    },
    listarPessoasNomes: async () => {
        return await api.get('pessoa/listanomes')
    },
    listarDiaSemana: async () => {
        return await api.get('diasemana')
    },
    salvarEvento: async (evento) => {
        return await api.post('/agenda', evento)
    },
    confirmarEvento: async (dados) => {
        return await api.post('agenda/confirmar', dados);
    },
    createUser: async (user) => {
        return await api.post('/pessoa/create', user)
    },
    updateUser: async (user) => {
        return await api.post('/usuario/update', user)
    },
    updatePassword: async (dados) => {
        return await api.post('/pessoa/updatePassword', dados);
    },
    excluiPessoa: async (id) => {
        return await api.delete('/pessoa/' + id)
    },
    atualizaEvento: async (evento) => {
        return await api.post('/agenda/edit', evento)
    },
    excluiEvento: async (id, replicarAlteracoes) => {
        return await api.delete('/agenda/' + id)
    },
    listaEventos: async () => {
        return await api.get('agenda/listAll')
    },
    listaEventosFilter: async (dados) => {
        return await api.post("agenda/busca", dados);
    },
    listaLocaisFilter: async (dados) => {
        return api.post('local/lista', dados)
    },
    listaProfissionaisFilter: async (dadosFiltro) => {
        return await api.post('profissional/lista', dadosFiltro)
    },
    buscaProfissionaisFilter: async (dadosFiltro) => {
        return await api.post('profissional/busca', dadosFiltro)
    },
    editProfissional: async (id) => {
        return await api.get('profissional/' + id)
    },
    salvarProfissional: async (dados) => {
        return await api.post('profissional/cadastrar', dados);
    },

    listaEmpresaPJFilter: async (dadosFiltro) => {
        return await api.post('empresa-pj/lista', dadosFiltro)
    },
    buscaEmpresaPJFilter: async (dadosFiltro) => {
        return await api.post('profissional/busca', dadosFiltro)
    },
    editEmpresaPJ: async (id) => {
        return await api.get('empresa-pj/' + id);
    },
    salvarEmpresaPJ: async (dados) => {
        return await api.post('profissional/cadastrar', dados);
    },

    listaEspecializacao: async (dadosFiltro) => {
        return await api.post('profissional/especializacao', dadosFiltro)
    },
    geraRelatorioFinanceiro: async (dados) => {
        return await api.post('relatorio/financeiro', dados);
    },
    buscarTotaisFechamentoMes: async (dados) => {
        return await api.post('fechamento/totais-mes', dados);
    },
    geraRelatorioPDF: async (dados) => {
        return await api.post('relatorio/export', dados);
    },
    geraRelatorioGeral: async (dados) => {
        return await api.post('relatorio/geral', dados);
    },
    exportarRelatorioFinanceiroExcel: async (dados) => {
        return await api.post('relatorio/financeiro/export/excel', dados);
    },
    exportarRelatorioFinanceiroGeralExcel: async (dadosFiltro) => {
        return await api.post('relatorio/financeiro/export/geral/excel', dadosFiltro)
    },
    exportarRelatorioFinanceiroHmtj: async (dadosFiltro) => {
        return await api.post('relatorio/financeiro/export/hmtj', dadosFiltro)
    },
    exportarAgendaExcel: async (dadosFiltro) => {
        return await api.post('relatorio/agenda/excel', dadosFiltro)
    },
    exportarRelatorioFinanceiroConsolidado: async (dados) => {
        return await api.post('relatorio/financeiro/export/consolidado', dados);
    },
    exportarRelatorioFinanceiroDetalhado: async (dados) => {
        return await api.post('relatorio/financeiro/export/detalhado', dados);
    },
    exportarRelatorioPersonalizado: async (dados) => {
        return await api.post('relatorio/personalizado', dados);
    },
    exportarRelatorioFolhaPonto: async (dados) => {
        return await api.post('relatorio/financeiro/export/folha-ponto', dados);
    },
    geraRelatorioFinanceiro: async (dados) => {
        return await api.post('relatorio/financeiro', dados);
    },
    exportarCredenciamentos: async (dados) => {
        return await api.post('credenciamento/export/json', dados);
    },
    exportarRelatorioCalendario: async (dados) => {
        return await api.post('relatorio/agenda/calendario', dados);
    },
    listaUsuariosFilter: async (dados) => {
        return await api.post('usuario/listar', dados);
    },
    listaTiposFilter: async (dados) => {
        return await api.post('tipo/lista', dados);
    },
    listaTiposApuracao: async (dados) => {
        return await api.post('tipo-apuracao/lista', dados);
    },
    recuperaSituacoes: async (dados) => {
        return await api.post('situacao/lista', dados);
    },
    gravarFechamentoAgenda: async (dados) => {
        return await api.post('fechamento/gravar', dados);
    },
    alterarSituacaoFechamentoAgenda: async (dadosFiltro) => {
        return await api.post('fechamento/alterar-situacao', dadosFiltro)
    },
    cancelarFechamentoAgenda: async (dados) => {
        return await api.post('fechamento/cancela', dados);
    },
    buscarFormulario: async (dadosFiltro) => {
        return await api.post('formulario/buscar', dadosFiltro)
    },
    buscarFormularioCredenciamento: async (dados) => {
        return await api.post('credenciamento/preencher', dados);
    },
    abrirCredenciamento: async (dados) => {
        return await api.post('credenciamento/abrir', dados)
    },
    buscarCredenciamentoPeloIdEncrypt: async (id) => {
        return await api.get('credenciamento/buscar/' + id);
    },
    excluirCredenciamento: async (dados) => {
        return await api.post('credenciamento/excluir', dados);
    },
    cancelarCredenciamento: async (dados) => {
        return await api.post('credenciamento/cancelar', dados);
    },
    gerarDashboardCredenciamento: async (dados) => {
        return await api.post('credenciamento/dashboard', dados);
    },
    listarFechamento: async (dadosFiltro) => {
        return await api.post('fechamento/listar', dadosFiltro)
    },
    copiarAgenda: async (dadosFiltro) => {
        return await api.post('fechamento/copiar', dadosFiltro)
    },
    listarEscala: async (dados) => {
        return await api.post('escala/lista', dados)
    },
    editEscala: async (id) => {
        return await api.get('escala/' + id);
    },
    salvarEscala: async (escala) => {
        return await api.post('/escala/salvar', escala)
    },
    excluirAgendas: async (dadosFiltro) => {
        return await api.post('agenda/escala/excluir', dadosFiltro)
    },
    excluirLoteAgenda: async (dados) => {
        return await api.post('agenda/excluir/lista', dados)
    },
    excluirEscala: async (id) => {
        return await api.delete('/escala/delete/' + id)
    },
    listaSituacoesFechamento: async (dadosFiltro) => {
        return await api.post('fechamento/listaSituacoes', dadosFiltro)
    },
    listaSituacoesGeral: async (dados) => {
        return await api.post('situacao/lista-geral', dados)
    },
    listaHistoricoAgenda: async (dadosFiltro) => {
        return await api.post('agenda/historico', dadosFiltro)
    },
    listaHistoricoFechamento: async (dadosFiltro) => {
        return await api.post('fechamento/historico', dadosFiltro)
    },
    listaHistoricoCredenciamento: async (dados) => {
        return await api.post('credenciamento/historico', dados)
    },
    buscarFechamento: async (dadosFiltro) => {
        return await api.post('fechamento/buscar', dadosFiltro)
    },
    copiarAgenda: async (dadosFiltro) => {
        return await api.post('agenda/copiar', dadosFiltro)
    },
    gerarDashboard: async (dados) => {
        return await api.post('relatorio/dashboard', dados)
    },
    imprimirAgenda: async (dadosFiltro) => {
        return await api.post('relatorio/escala', dadosFiltro)
    },
    recuperarSenha: async (dados) => {
        return await api.post('usuario/recuperarSenha/email', dados)
    },
    resetarSenha: async (dados) => {
        return await api.post('usuario/resetSenha', dados)
    },
    listaSituacoesLocal: async (dados) => {
        return await api.post('local/situacoes', dados)
    },
    listaSituacoesFechamentoLocal: async (dados) => {
        return await api.post('local/situacoes/fechamento', dados)
    },
    listaTiposLocal: async (dados) => {
        return await api.post('local/tipos', dados)
    },
    buscarConfiguracaoLocal: async (dados) => {
        return await api.post('local/configuracao', dados)
    },
    buscarProfissionaisLocal: async (dados) => {
        return await api.post('local/profissional', dados)
    },
    editLocal: async (id) => {
        return await api.get('local/' + id)
    },
    saveLocal: async (dados) => {
        return await api.post('local/save', dados)
    },
    deleteLocal: async (id) => {
        return await api.delete('local/' + id)
    },
    saveConfiguracaoLocal: async (dados) => {
        return await api.post('local/configuracao/save', dados)
    },
    recuperaGruposUsuario: async (dados) => {
        return await api.post('grupoUsuario/lista', dados)
    },
    editUsuario: async (id) => {
        return await api.get('usuario/' + id)
    },
    saveUsuario: async (dados) => {
        return await api.post('usuario/save', dados)
    },
    deleteUsuario: async (id) => {
        return await api.delete('usuario/' + id)
    },
    deleteTipo: async (id) => {
        return await api.delete('tipo/' + id)
    },
    buscarPessoaLocal: async (dados) => {
        return await api.post('pessoa/local', dados);
    },
    atualizarPessoaLocal: async (dados) => {
        return await api.post('pessoa/local/atualizar', dados);
    },
    atualizarLoteAgenda: async (dados) => {
        return await api.post('/agenda/salvar/lote', dados)
    },
    buscarDadosManutencaoAgenda: async (dados) => {
        return await api.post('agenda/dados/manutencao', dados)
    },
    buscarParametroCadastro: async (dados) => {
        return await api.post('parametro/buscar', dados);
    },
    listaEspecialidadeFilter: async (dados) => {
        return await api.post('tipo/especialidade/lista', dados)
    },
    listaTipoServico: async (dados) => {
        return await api.post('tipo-servico/lista', dados);
    },
    editTipo: async (id) => {
        return await api.get('tipo/' + id)
    },
    saveTipo: async (dados) => {
        return await api.post('tipo/save', dados);
    },
    editGrupoUsuario: async (id) => {
        return await api.get('grupoUsuario/' + id)
    },
    saveGrupoUsuario: async (dados) => {
        return await api.post('grupoUsuario/save', dados);
    },
    deleteGrupoUsuario: async (id) => {
        return await api.delete('grupoUsuario/' + id)
    },
    editSituacao: async (id) => {
        return await api.get('situacao/' + id)
    },
    recuperaEmpresa: async (dados) => {
        return await api.post('empresa/lista', dados)
    },
    editEmpresa: async (id) => {
        return await api.get('empresa/' + id)
    },
    saveEmpresa: async (dados) => {
        return await api.post('empresa/save', dados)
    },
    deleteEmpresa: async (id) => {
        return await api.delete('empresa/' + id)
    },
    buscarEmpresaPeloIdentificador: async (dados) => {
        return await api.post('empresa/buscar/identificador', dados);
    },
    listaCredenciamento: async (dados) => {
        return await api.post('credenciamento/lista', dados);
    },
    listaCredenciamentoPJ: async (dados) => {
        return await api.post('credenciamento/lista-pj', dados);
    },
    listaCredenciamentoPF: async (dados) => {
        return await api.post('credenciamento/lista-pf', dados);
    },
    exportarListaCredenciamento: async (dados) => {
        return await api.post('credenciamento/lista/export', dados);
    },
    buscaEmpresaCredenciamento: async (dados) => {
        return await api.post('credenciamento/busca/empresa', dados);
    },
    aprovarCredenciamento: async (dados) => {
        return await api.post('credenciamento/aprovar', dados)
    },
    reprovarCredenciamento: async (dados) => {
        return await api.post('credenciamento/reprovar', dados)
    },
    atualizarCredenciamento: async (dados) => {
        return await api.post('credenciamento/atualizar', dados);
    },
    downloadTermo: async (dados) => {
        return await api.post('credenciamento/download/termo', dados);
    },
    buscarVagasPlantao: async (dados) => {
        return await api.post('vaga/buscar', dados);
    },
    buscarVagaPlantao: async (dados) => {
        return await api.post('vaga/aceitar/abrir', dados);
    },
    candidatarVagaPlantao: async (dados) => {
        return await api.post('vaga/aceitar', dados);
    },
    listaAprovacaoCandidato: async (dados) => {
        return await api.post('vaga/aprovar/lista', dados)
    },
    abrirAprovacaoCandidato: async (dados) => {
        return await api.post('vaga/aprovar/abrir', dados)
    },
    aprovarCandidato: async (dados) => {
        return await api.post('vaga/aprovar', dados)
    },
    reprovarCandidato: async (dados) => {
        return await api.post('vaga/reprovar', dados)
    },
    listaCandidaturas: async (dados) => {
        return await api.post('vaga/candidatura/lista', dados);
    },
    abrirCandidatura: async (dados) => {
        return await api.post('vaga/candidatura/abrir', dados);
    },
    cancelarCandidatura: async (dados) => {
        return await api.post('vaga/candidatura/cancelar', dados);
    },
    buscarDadosFiltroVagas: async (dados) => {
        return await api.post('vaga/filtro', dados);
    },
    buscarBancos: async () => {
        return await api.get('mobile/banco');
        //return await api.get('mobile/banco')
    },
    listaTipoEspecializacao: async (dados) => {
        return await api.post('cadastro/tipo-especializacao', dados);
    },
    listaEspecialidade: async (dados) => {
        return await api.post('cadastro/especialidade', dados);
    },
    listaNivelEspecializacao: async () => {
        return await api.get('cadastro/nivel-especializacao');
    },
    saveEspecializacao: async (dados) => {
        return await api.post('profissional/especializacao/salvar', dados)
    },
    deleteEspecializacao: async (id) => {
        return await api.delete('profissional/especializacao/excluir/' + id)
    },
    criarConta: async (dados) => {
        return await api.post('mobile/user/create', dados);
    },
    posCriarConta: async (dados) => {
        return await api.post('credenciamento/pos-criar-conta', dados);
    },
    enviarDadosCredenciamento: async (dados) => {
        return await api.post('credenciamento/enviarDados', dados);
    },
    posEnviarCredenciamento: async (dados) => {
        return await api.post('credenciamento/pos-enviar-credenciamento', dados);
    },
    download: async (idDocumento) => {
        return await api.get('arquivo/download/' + idDocumento);
    },
    buscarPerfil: async (dados) => {
        return await api.post('mobile/user/profile', dados);
    },
    buscarDadosConta: async (id) => {
        return await api.get('usuario/dados/' + id);
    },
    atualizarConta: async (idPessoa, dados) => {
        return await api.put('mobile/user/' + idPessoa, dados);
    },
    listarPagamentos: async (dados) => {
        return await api.post('pagamento/listar', dados);
    },
    abrirPagamento: async (id) => {
        return await api.get('pagamento/' + id);
    },
    listaClassificacao: async (dados) => {
        return await api.post('classificacao/lista', dados);
    },
    editClassificacao: async (id) => {
        return await api.get('classificacao/' + id);
    },
    saveClassificacao: async (dados) => {
        return await api.post('classificacao/save', dados);
    },
    deleteClassificacao: async (id) => {
        return await api.delete('classificacao/' + id);
    },
    listaTipoGeral: async (dados) => {
        return await api.post('cadastro/tipo-geral', dados);
    },
    adicionarClassificacao: async (dados) => {
        return await api.post('tag/adicionar-classificacao', dados);
    },
    removerClassificacao: async (dados) => {
        return await api.post('tag/remover-classificacao', dados);
    },
    anunciarVaga: async (dados) => {
        return await api.post('vaga/divulgar', dados);
    },
    listaDocumento: async (dados) => {
        return await api.post('documento/termo', dados);
    },
    buscaTermoUso: async (dados) => {
        return await api.post('documento/termo-uso', dados);
    },
    buscaPoliticaPrivacidade: async (dados) => {
        return await api.post('documento/politica-privacidade', dados);
    },
    listaPermissaoGeral: async (dados) => {
        return await api.post('usuario/permissao-geral', dados);
    },
    buscarVersao: async () => {
        return await api.get('usuario/versao')
    },
    listaLiberacaoAgenda: async (dados) => {
        return await api.post('liberacao/lista', dados);
    },
    listabuscarUsuariosAprovadores: async (dados) => {
        return await api.post('usuario/aprovador', dados);
    },
    editAprovacao: async (dados) => {
        return await api.post('liberacao/edit', dados);
    },
    aprovarAprovacao: async (dados) => {
        return await api.post('liberacao/aprovar/diretor', dados);
    },
    reprovarAprovacao: async (dados) => {
        return await api.post('liberacao/reprovar/diretor', dados);
    },
    aprovarAprovacaoFinanceiro: async (dados) => {
        return await api.post('liberacao/aprovar/financeiro', dados);
    },
    reprovarAprovacaoFinanceiro: async (dados) => {
        return await api.post('liberacao/reprovar/financeiro', dados);
    },
    cancelarAprovar: async (dados) => {
        return await api.post('liberacao/aprovar/diretor/cancelar', dados);
    },
    cancelarReprovar: async (dados) => {
        return await api.post('liberacao/reprovar/diretor/cancelar', dados);
    },
    cancelarAprovarFinanceiro: async (dados) => {
        return await api.post('liberacao/aprovar/financeiro/cancelar', dados);
    },
    cancelarReprovarFinanceiro: async (dados) => {
        return await api.post('liberacao/reprovar/financeiro/cancelar', dados);
    },
    buscarPerfilAprovador: async (dados) => {
        return await api.post('liberacao/perfil', dados);
    },
    buscarRelatoriosAgenda: async (dados) => {
        return await api.post('agenda/relatorios', dados);
    },
    dadosNovaSituacaoLocal: async (id) => {
        return await api.get('local/situacao/novo/' + id)
    },
    editSituacaoLocal: async (id) => {
        return await api.get('local/situacao/' + id)
    },
    saveSituacaoLocal: async (dados) => {
        return await api.post('local/situacao/save', dados)
    },
    deleteSituacaoLocal: async (id) => {
        return await api.delete('local/situacao/' + id)
    },
    dadosNovaSituacaoFechamentoLocal: async (id) => {
        return await api.get('local/situacao/fechamento/novo/' + id)
    },
    editSituacaoFechamentoLocal: async (id) => {
        return await api.get('local/situacao/fechamento/' + id)
    },
    saveSituacaoFechamentoLocal: async (dados) => {
        return await api.post('local/situacao/fechamento/save', dados)
    },
    deleteSituacaoFechamentoLocal: async (id) => {
        return await api.delete('local/situacao/fechamento/' + id)
    },
    deleteProfissionalLocal: async (dados) => {
        return await api.post('local/profissional/excluir', dados);
    },
    saveProfissionalLocal: async (dados) => {
        return await api.post('local/profissional/save', dados)
    },
    dadosNovoTipoLocal: async (id) => {
        return await api.get('local/tipo/novo/' + id)
    },
    editTipoLocal: async (id) => {
        return await api.get('local/tipo/' + id)
    },
    saveTipoLocal: async (dados) => {
        return await api.post('local/tipo/save', dados)
    },
    deleteTipoLocal: async (id) => {
        return await api.delete('local/tipo/' + id)
    },
    autorizarGoogleAgenda: async () => {
        return await api.get('google/authorize');
    },
    excluirDadosMinhaConta: async () => {
        return await api.post('/minha-conta/excluir-dados', {})
    },
    excluirMinhaConta: async () => {
        return await api.post('/minha-conta/excluir-conta', {})
    },
}